module.exports = __webpack_public_path__ + "static/giletPrimoRVFrontLogo-42f8e84d72fbb295a0ceb546afff83c4.jpg";